import Sounds from '../content/json/action-sounds.js';
import Delirium0 from '../content/json/delirium0.js';
import Delirium0Actions from '../content/json/delirium0-actions.js';
import Delirium0Room from '../content/json/delirium0-room-layout.js';
import Delirium1 from '../content/json/delirium1.js';
import Delirium1Actions from '../content/json/delirium1-actions.js';
import Delirium1Room from '../content/json/delirium1-room-layout.js';
import Delirium2 from '../content/json/delirium2.js';
import Delirium2Actions from '../content/json/delirium2-actions.js';
import Delirium2Room from '../content/json/delirium2-room-layout.js';
import Delirium3 from '../content/json/delirium3.js';
import Delirium3Actions from '../content/json/delirium3-actions.js';
import Delirium3Room from '../content/json/delirium3-room-layout.js';
import Delirium4 from '../content/json/delirium4.js';
import Delirium4Actions from '../content/json/delirium4-actions.js';
import Delirium4Room from '../content/json/delirium4-room-layout.js';
import Delirium5 from '../content/json/delirium5.js';
import Delirium5Actions from '../content/json/delirium5-actions.js';
import Delirium5Room from '../content/json/delirium5-room-layout.js';
import Delirium6 from '../content/json/delirium6.js';
import Delirium6Actions from '../content/json/delirium6-actions.js';
import Delirium6Room from '../content/json/delirium6-room-layout.js';
import Delirium7 from '../content/json/delirium7.js';
import Delirium7Actions from '../content/json/delirium7-actions.js';
import Delirium7Room from '../content/json/delirium7-room-layout.js';
import VideoMarkers from '../content/json/video-markers.js';
import EndVideoNl from '../content/json/nl_NL-completion-videos.js';
import EndVideoEn from '../content/json/en_GB-completion-videos.js';
import {EndVideoCatalog, EndVideoLocaleMap} from "@/store/ContentTypes";

const config =
{
    sounds: Sounds,
    localized: {
        hotspotImages: {
            whiteboard: [
                'item_closeup_whiteboard_ma.jpg',
                'item_closeup_whiteboard_di.jpg',
                'item_closeup_whiteboard_wo.jpg',
                'item_closeup_whiteboard_do.jpg'
            ]
        },
        roomImages: {
            whiteboard: [
                'nurseview_whiteboard_ma.png',
                'nurseview_whiteboard_di.png',
                'nurseview_whiteboard_wo.png',
                'nurseview_whiteboard_do.png'
            ]
        }
    },
    hotspotInfo: {
        communiceren: { icon: "talk2pat", orientation: "right" },
        exit: { icon: "exit", orientation: "up" },
        klok: { icon: "clock", orientation: "downleft" },
        whiteboard: { icon: "whiteboard", orientation: "left" },
        lamellen: { icon: "blinds", orientation: "up" },
        bril: { icon: "glasses", orientation: "right" },
        infuus: { icon: "drip", orientation: "right" },
        medicatietoedienen: { icon: "medication", orientation: "up" },
        overleggenmetchirurg: { icon: "talk2arts", orientation: "up" },
        cad: { icon: "cad", orientation: "up" },
        ontbijt: { icon: "breakfast", orientation: "down" },
        zweedseband: { icon: "zweedseBand", orientation: "right" },
    },
    mobileButtonKeys: {
        mobielecomputerzaalarts: "contactarts",
        mobielecomputerpartner: "contactpartner",
        mobielecomputerdos: "dos",
        mobielecomputerfysio: "fysio",
        mobielecomputerha: "hadossier",
        mobielecomputerdossier: "dossier",
        mobielecomputerglucose: "glucose",
        mobielecomputerlab: "lab",
        mobielecomputersedatie: "sedatie",
        mobielecomputerbloed: "transfusie"
    },
    hotspotImages: {
        bril: 'item_closeup_bril.jpg',
        cad: 'item_closeup_CAD.jpg',
        klok: 'item_closeup_klok.jpg',
        lamellen: 'item_closeup_lamellen.jpg',
        waskom: 'item_closeup_wassen.jpg',
        waterglas: 'item_closeup_glaswater.jpg',
        medicatietoedienen: 'item_closeup_medicatie.jpg',
        infuus: 'item_closeup_infuus.jpg',
        ontbijt: 'item_closeup_ontbijt.jpg',
        whiteboard: 'item_closeup_whiteboard_leeg.jpg',
        zweedseband: 'item_closeup_zweedseband.jpg'
    },
    situations: [
        {
            situation: Delirium0,
            actions: Delirium0Actions,
            room: Delirium0Room
        },
        {
            situation: Delirium1,
            actions: Delirium1Actions,
            room: Delirium1Room
        },
        {
            situation: Delirium2,
            actions: Delirium2Actions,
            room: Delirium2Room
        },
        {
            situation: Delirium3,
            actions: Delirium3Actions,
            room: Delirium3Room
        },
        {
            situation: Delirium4,
            actions: Delirium4Actions,
            room: Delirium4Room
        },
        {
            situation: Delirium5,
            actions: Delirium5Actions,
            room: Delirium5Room
        },
        {
            situation: Delirium6,
            actions: Delirium6Actions,
            room: Delirium6Room
        },
        {
            situation: Delirium7,
            actions: Delirium7Actions,
            room: Delirium7Room
        },
    ],
    videoMarkers: VideoMarkers,
    endVideos: <EndVideoLocaleMap> {
        "nl_NL": <EndVideoCatalog> EndVideoNl,
        "en_GB": <EndVideoCatalog> EndVideoEn,
    }
};

// console.log('kan dit uberhaubt');
// console.log(config.sounds.sounds[0].value);
// console.log(config.situations[3].room.icons[2].x, config.situations[3].room.icons[2].y);
// console.log(config.situations[3].actions.items[5].name);
// console.log(config.situations[3].actions.items[0].actions[0].scores[0].forPatientState);
// console.log('het kan ook echt!');

export default config;
